import ButtonGroup from "@/components/ui/molecules/ButtonGroup/ButtonGroup";

type AdminSettingsCommunicateKeepMailsProps = {
  label: string;
  value: number;
  onChange: (value: number) => void;
}

const AdminSettingsCommunicateKeepMails = ({ label, value, onChange }: AdminSettingsCommunicateKeepMailsProps) => {
  const options = [
    {label: '10 Jours', value: '10'},
    {label: '30 Jours', value: '30'},
    {label: '60 Jours', value: '60'},
    {label: 'Indéfiniment', value: '0'}
  ];

  return (
    <div className="flex flex-col gap-2w md:flex-row md:items-center md:justify-between">
      <span className='text-body1'>{label}</span>
      <ButtonGroup className='md:flex-nowrap' options={options} onChange={(value) => onChange(parseInt(value))} value={value?.toString()} />
    </div>
  );
}

export default AdminSettingsCommunicateKeepMails;